import {populateGeneralData} from "../../utils/populateGeneralData";

export {getAuthor} from "../../author/getAuthor";
export {addImpression} from "../../utils/addImpression";
export {decorateDateString} from "../../utils/decorateDateString";
export {hostnameFromURL} from "../../utils/hostnameFromURL";
const alreadyLoadedElements = [];

export function positionEventContents(jsonObj, lazyLoadOnThisPage, modalElement = null) {
    const data = $.parseJSON(jsonObj);
    let elements = communityType === 1 ? data.timeline_elements : data.event_elements;
    const eventElements = data.event_elements;
    let counter = 0;
    if (modalElement) {
        elements = data.event_elements;
    }
    const formatTime = (time) => {
        if (!time) return "";
        const date = stringToDate(`2000-01-01 ${time}`);
        const hours = String(date.getHours()).padStart(2, "0");
        const minutes = String(date.getMinutes()).padStart(2, "0");
        return `${hours}:${minutes}`;
    };

    const formatDateRange = (start, end) => {
        const formatDate = (d) => $.datepicker.formatDate('dd.mm.yy', stringToDate(d));
        if (!end || formatDate(start) === formatDate(end)) return formatDate(start);
        return `${formatDate(start)}  -  ${formatDate(end)}`;
    };
    $.each(elements, (key, value) => {
        let timeLineElement = communityType === 1 ? eventElements[value.post_id] : value;
        if (modalElement) {
            timeLineElement = value;
        }
        let container = $(`#${value.id}.timeline_entry`);
        if (!modalElement && (timeLineElement.active.toString() !== "1" || (!container?.length || container[0]?.classList.contains("already-loaded")))) {
            container.remove();
            return;
        } else {
            container?.[0]?.classList.add("already-loaded");
        }
        let clonedBox = $(".event_box_prototype").clone().appendTo(container);
        if (modalElement) {
            clonedBox = modalElement;
        }

        clonedBox.removeClass("hidden");
        clonedBox.removeClass("event_box_prototype");
        container.find(".js-spinner").hide();

        const validityFrom = timeLineElement.validity_from ? decorateDateString(timeLineElement.validity_from) : "";
        const link = `/${siteCode}/${mainLanguageCode}/veranstaltungen/post/${timeLineElement.id}/`;
        clonedBox.find(".js-timeline-link").attr("href", link);
        if (!modalElement) {
            initEventModalBox(container, jsonObj);
        }
        clonedBox.find(".js-post-date").text(validityFrom);
        clonedBox.find(".js-headline").text(timeLineElement.description);
        populateGeneralData(clonedBox, timeLineElement);

        if (timeLineElement.author) getAuthor(timeLineElement, value);

        // Date and month details
        const dateObj = stringToDate(timeLineElement.event_date);
        const day = `${$.datepicker.formatDate('dd', dateObj)}.`;
        const monthName = getMonthNameFromNumber($.datepicker.formatDate('mm', dateObj));
        const year = $.datepicker.formatDate('yy', dateObj);

        const dateText = formatDateRange(timeLineElement.event_date, timeLineElement.event_end_date);

        // Time formatting
        const startTime = formatTime(timeLineElement.event_time);
        const endTime = formatTime(timeLineElement.event_end_time);
        let timeText = "o.A.";

        if (startTime && endTime) {
            timeText = startTime === endTime ? `${startTime} Uhr` : `${startTime} - ${endTime} Uhr`;
        } else if (startTime) {
            timeText = `ab ${startTime} Uhr`;
        } else if (endTime) {
            timeText = `bis ${endTime} Uhr`;
        }

        // Image
        const imageSrc = timeLineElement.image
            ? `/userdata/event/resize/${timeLineElement.image}`
            : `/layout/frontend/stiegl/dist/images/event-noimage.jpg`;

        clonedBox.find(".js-day").text(day);
        clonedBox.find(".js-month").text(monthName);
        clonedBox.find(".js-year").text(year);
        clonedBox.find(".js-timeline-image,.js-event-image").html(
            `<img src="${imageSrc}" alt="${timeLineElement.description}" title="${timeLineElement.description}" />`
        );
        clonedBox.find(".js-time").text(timeText);
        clonedBox.find(".js-date").text(dateText);
        clonedBox.find(".js-address").html(timeLineElement.address.replace(/\r\n/g, "<br />"));
        addImpression(value.id);

        clonedBox.find(".js-spinner").hide();

        /**
         * Content for detailpage
         */
        clonedBox.find(".js-event-description").html(value.content);
        let map = $("#map");
        clonedBox.find('.mapWrapper').html('');
        clonedBox.find('.mapWrapper').append(map);
        /**
         * content for modal
         */
        if (modalElement) {
            initModalMap(timeLineElement.lat, timeLineElement.lng);
            clonedBox.find(".js-headline").remove();
            clonedBox.find(".js-modal-title").text(timeLineElement.description);
            var icalLink = clonedBox.find(".ical-event-link");
            clonedBox.find(".ical").append(icalLink);
            icalLink.removeClass("hidden");

        }
        if (value.link !== "" && value.link !== null) {
            var externalLinkContainer = clonedBox.find('.iconList__content.external-link');
            externalLinkContainer.html($('<a>', {
                href: value.link,
                target: '_blank',
                html: hostnameFromURL(value.link),
                class: 'link'
            }));
        } else {
            clonedBox.find(".iconList__content.external-link").closest(".iconList__line").remove();
        }
        clonedBox.find("a").not($(".event_content .ical a")).not($(".more_comments_link a")).attr("href", link);

        if (data.event_images.length > 0) {
            var imageContainer = clonedBox.find(".event_images");
            $.each(data.event_images, function (key, image) {
                imageContainer.append('<div class="imageGallery__image ' + hidden + '" data-count="' + (countImage - 1) + '" onclick="MagicZoom.expand(\'' + idZoom + '\');"><img src=' + image.filename + '"/userdata/event/resize" title="' + image.description + '" alt="' + image.description + '" />' + moreCounter + '</div>');
            });
        } else {
            clonedBox.find(".js-event-gallery").remove();
        }

        counter++;
    });

    lazyLoad = lazyLoadOnThisPage;
}

function initEventModalBox(element, jsonObj) {
    if (!element?.[0]) return;
    const eventObj = $.parseJSON(jsonObj);

    eventObj.timeline_elements = [];
    const $modal = $('.js-event-modal');
    let isOpen = false;
    element[0].addEventListener('click', function (event) {
        if (event.target.matches('.js-timeline-link')) {
            event.preventDefault();
            const url = event.target.getAttribute('href');
            history.pushState({modal: true}, '', url);
            isOpen = true;
            positionEventContents(JSON.stringify(eventObj), true, $modal);
            $modal.modal("show");
        }
    });
    $modal.on('hidden.bs.modal', function (e) {
        if (isOpen && history.state && history.state.modal) {
            history.back();
            isOpen = false;
        }
    });
    window.addEventListener('popstate', function (event) {
        if ($modal.hasClass('in')) {
            $modal.modal('hide');
        }
    });
}

function initModalMap(lat, lng) {
    var place = {lat: parseFloat(lat), lng: parseFloat(lng)};
    var map = new google.maps.Map(document.getElementById('map'), {
        zoom: 12,
        center: place,
        styles: [
            {
                "stylers": [
                    {
                        "hue": "#dd0d0d"
                    }
                ]
            },
            {
                "featureType": "road",
                "elementType": "labels",
                "stylers": [
                    {
                        "visibility": "off"
                    }
                ]
            },
            {
                "featureType": "road",
                "elementType": "geometry",
                "stylers": [
                    {
                        "lightness": 100
                    },
                    {
                        "visibility": "simplified"
                    }
                ]
            }
        ]
    });
    var marker = new google.maps.Marker({
        position: place,
        map: map,
        icon: '/layout/frontend/stiegl/dist/images/maps-marker.png'
    });
}